import { render, staticRenderFns } from "./PagesTilesWidget.vue?vue&type=template&id=5c87d9b0&"
import script from "./PagesTilesWidget.vue?vue&type=script&lang=js&"
export * from "./PagesTilesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports